"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { Text } from "@nxt-costco-com/forge-components";
import * as Icons from "@nxt-costco-com/forge-icons";
import { useProductTileData } from "../../../../../../../hooks/useProductTileData/index.js";
import { memberOnlyContainerStyles, memberOnlyIconStyles } from "./styles.js";
const COMPONENT_NAME = "MemberOnlyItemBadge";
const MemberOnlyItemBadge = ({
  uniqueId,
  pdpNavigationUrl
}) => {
  const { translationsConfig } = useProductTileData();
  const { icons, translations } = translationsConfig || {};
  const memberOnlyIconName = icons == null ? void 0 : icons["memberOnlyIcon"];
  const MemberOnlyIcon = memberOnlyIconName ? Icons[memberOnlyIconName] : void 0;
  const memberOnlyText = (translations == null ? void 0 : translations["memberonlylabel"]) ? "Members Only" : "";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      onClick: () => {
        var _a;
        const navigationUrl = pdpNavigationUrl || ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.href) || "";
        window == null ? void 0 : window.open(navigationUrl);
      },
      "data-testid": `${COMPONENT_NAME}_${uniqueId}`,
      sx: memberOnlyContainerStyles,
      children: [
        MemberOnlyIcon && /* @__PURE__ */ jsx(MemberOnlyIcon, { sx: memberOnlyIconStyles }),
        /* @__PURE__ */ jsx(Text, { uniqueId: `${COMPONENT_NAME}_${uniqueId}`, variant: "t6", children: memberOnlyText })
      ]
    }
  );
};
export {
  MemberOnlyItemBadge
};
